module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "join-section"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xs": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    staticClass: "justify-center",
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center flex-column"
  }, [_c('p', {
    staticClass: "text-center mb-5"
  }, [_vm._v("\n            Join the community. "), _c('br'), _vm._v("\n            It’s all for you.\n          ")]), _vm._v(" "), (!_vm.isAuthenticated) ? _c('v-btn', {
    staticClass: "signup_btn",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(" Sign In ")]) : _c('v-btn', {
    staticClass: "signup_btn",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'AlbumIndex'
        })
      }
    }
  }, [_vm._v("Discover ")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60e50c9d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landingPages/Join.vue
// module id = 1744
// module chunks = 180